export const AuthorMap = {
  ADD_AUTHOR_START: "HDP_ADD_AUTHOR_START",
  ADD_AUTHOR_SUCCESS: "HDP_ADD_AUTHOR_SUCCESS",
  ADD_AUTHOR_ERROR: "HDP_ADD_AUTHOR_ERROR",
  GET_ALL_AUTHOR_START: "HDP_GET_ALL_AUTHOR_START",
  GET_ALL_AUTHOR_SUCCESS: "HDP_GET_ALL_AUTHOR_SUCCESS",
  GET_ALL_AUTHOR_ERROR: "HDP_GET_ALL_AUTHOR_ERROR",
  UPDATE_AUTHOR_START: "HDP_UPDATE_AUTHOR_START",
  UPDATE_AUTHOR_SUCCESS: "HDP_UPDATE_AUTHOR_SUCCESS",
  UPDATE_AUTHOR_ERROR: "HDP_UPDATE_AUTHOR_ERROR",
  DELETE_AUTHOR_START: "HDP_DELETE_AUTHOR_START",
  DELETE_AUTHOR_SUCCESS: "HDP_DELETE_AUTHOR_SUCCESS",
  DELETE_AUTHOR_ERROR: "HDP_DELETE_AUTHOR_ERROR",
  GET_AUTHOR_DETAIL_START: "HDP_GET_AUTHOR_DETAIL_START",
  GET_AUTHOR_DETAIL_SUCCESS: "HDP_GET_AUTHOR_DETAIL_SUCCESS",
  GET_AUTHOR_DETAIL_ERROR: "HDP_GET_AUTHOR_DETAIL_ERROR",
  GET_AUTHOR_LIST_START: "HDP_GET_AUTHOR_LIST_START",
  GET_AUTHOR_LIST_SUCCESS: "HDP_GET_AUTHOR_LIST_SUCCESS",
  GET_AUTHOR_LIST_ERROR: "HDP_GET_AUTHOR_LIST_ERROR",

  SEARCH_TEXT_CHANGE: "HDP_AUTHOR_SEARCH_TEXT_CHANGE",
  REFRESH_AUTHOR_LIST: "HDP_REFRESH_AUTHOR_LIST",
  SET_AUTHOR_BATCH_NUMBER: "HDP_SET_AUTHOR_BATCH_NUMBER",
};

export const AuthorManagementActions = {
  getAllAuthorStart: (data) => ({
    type: AuthorMap.GET_ALL_AUTHOR_START,
    payload: data,
  }),
  getAllAuthorSuccess: (data) => ({
    type: AuthorMap.GET_ALL_AUTHOR_SUCCESS,
    payload: data,
  }),
  getAllAuthorError: () => ({
    type: AuthorMap.GET_ALL_AUTHOR_ERROR,
  }),

  addAuthorStart: () => ({ type: AuthorMap.ADD_AUTHOR_START }),
  addAuthorSuccess: (data) => ({
    type: AuthorMap.ADD_AUTHOR_SUCCESS,
    payload: data,
  }),
  addAuthorError: (errors) => ({
    type: AuthorMap.ADD_AUTHOR_ERROR,
    payload: { errors },
  }),

  updateAuthorStart: () => ({ type: AuthorMap.UPDATE_AUTHOR_START }),
  updateAuthorSuccess: (data) => ({
    type: AuthorMap.UPDATE_AUTHOR_SUCCESS,
    payload: data,
  }),
  updateAuthorError: (errors) => ({
    type: AuthorMap.UPDATE_AUTHOR_ERROR,
    payload: { errors },
  }),

  deleteAuthorStart: () => ({ type: AuthorMap.DELETE_AUTHOR_START }),
  deleteAuthorSuccess: (data) => ({
    type: AuthorMap.DELETE_AUTHOR_SUCCESS,
    payload: data,
  }),
  deleteAuthorError: (errors) => ({
    type: AuthorMap.DELETE_AUTHOR_ERROR,
    payload: { errors },
  }),

  getAuthorDetail: (data) => ({
    type: AuthorMap.GET_AUTHOR_DETAIL_START,
    payload: data,
  }),
  getAuthorDetailSuccess: (data) => ({
    type: AuthorMap.GET_AUTHOR_DETAIL_SUCCESS,
    payload: data,
  }),
  getAuthorDetailError: () => ({
    type: AuthorMap.GET_AUTHOR_DETAIL_ERROR,
  }),

  getAuthorListStart: (data) => ({
    type: AuthorMap.GET_AUTHOR_LIST_START,
    payload: data,
  }),
  getAuthorListSuccess: (data) => ({
    type: AuthorMap.GET_AUTHOR_LIST_SUCCESS,
    payload: data,
  }),
  getAuthorListError: () => ({ type: AuthorMap.GET_AUTHOR_LIST_ERROR }),

  searchTextChange: (data) => ({
    type: AuthorMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  refreshAuthorList: () => ({
    type: AuthorMap.REFRESH_AUTHOR_LIST,
  }),
  setAuthorBatchNumber: (data) => ({
    type: AuthorMap.SET_AUTHOR_BATCH_NUMBER,
    payload: data,
  }),
};
